import { useMemo } from 'react';
import { useHasWIVOrEIVAccess } from '@frontend/insurance-verification';
import { useSchedulePulseInsuranceTabContext } from '../context';

export const useGetLocationList = () => {
  const { locationIdWiseEIVCustomizationFlagDetails, locationIdWiseWIVCustomizationFlagDetails } =
    useHasWIVOrEIVAccess();

  const { getScopeName, selectedLocationIds, defaultAppointmentList } = useSchedulePulseInsuranceTabContext();

  const locationInfoList = useMemo(() => {
    return selectedLocationIds
      .filter(
        (locId) =>
          locationIdWiseEIVCustomizationFlagDetails?.[locId] || locationIdWiseWIVCustomizationFlagDetails?.[locId]
      )
      .map((locationId) => ({
        locationId,
        name: getScopeName(locationId),
        count: defaultAppointmentList.filter((appt) => appt.locationId === locationId).length,
      }));
  }, [
    defaultAppointmentList,
    getScopeName,
    locationIdWiseEIVCustomizationFlagDetails,
    locationIdWiseWIVCustomizationFlagDetails,
    selectedLocationIds,
  ]);

  return { locationInfoList, selectedLocationIds };
};
